import { computed, ref } from 'vue';
/**
 * Steps through a list one item at a time, e.g. through the rows of a datagrid in a details dialog.
 */
export function useItemNavigation(items, emit) {
    const currentIndex = ref(null);
    const currentItem = computed(() => currentIndex.value === null ? null : items.value[currentIndex.value] ?? null);
    const currentPosition = computed(() => currentIndex.value === null ? 0 : currentIndex.value + 1);
    const totalItems = computed(() => items.value.length);
    /**
     * Shows the given item.
     */
    function openItem(item) {
        const itemIndex = items.value.indexOf(item);
        currentIndex.value = itemIndex === -1 ? null : itemIndex;
    }
    /**
     * Goes one item back, unless the first one is shown.
     */
    function showPreviousItem() {
        if (currentIndex.value !== null && currentIndex.value > 0)
            currentIndex.value--;
    }
    /**
     * Goes one item forward, unless the last one is shown.
     */
    function showNextItem() {
        if (currentIndex.value !== null && currentIndex.value < items.value.length - 1)
            currentIndex.value++;
    }
    /**
     * Shows no item anymore.
     */
    function closeItem() {
        emit('details-dialog-close', currentItem.value);
        currentIndex.value = null;
    }
    return { currentItem, currentPosition, totalItems, openItem, showPreviousItem, showNextItem, closeItem };
}
